// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__TwOBq","body":"style_body__fYinH","search":"style_search__epm7x"};